import React, { FC, ReactElement, useState } from 'react';

import styles from './styles.module.scss';

import { InfoCircle, TableDataNotFound } from 'components';
import { AssetRowItems, TableHeader } from './components';

import { useAppSelector } from 'store';
import { tableDataSort } from 'helpers';

import { IOrganizationAssetsTable, ISortedParam } from 'types/interfaces';
import { TREASURY_TAB, TREASURY_TAB_DESCRIPTIONS } from '../../../../../../../../constants';
import { TableProBlur } from './components/TableProBlur';
import { assetsTableMock } from './contstants';

interface IDaoAssetsTableProps {
    isPremiumAllowed: boolean;
}

export const DaoAssetsTable: FC<IDaoAssetsTableProps> = ({ isPremiumAllowed }): ReactElement => {
    const { organizationDaoAssetsTable } = useAppSelector(({ organization }) => organization);

    const [sortedParam, setSortedParam] = useState<ISortedParam>({
        paramName: 'usdValue',
        descending: true,
    });

    const sortByParam = (param: string) => {
        setSortedParam({
            paramName: param,
            descending: sortedParam.paramName === param ? !sortedParam.descending : true,
        });
    };
    const dataToRender = organizationDaoAssetsTable?.length ? organizationDaoAssetsTable : assetsTableMock;
    const daoAssetsTableData = tableDataSort([...dataToRender], sortedParam);

    return (
        <>
            <div className={styles.tableWrapper}>
                <div className={styles.titleWrapper}>
                    <h4 className={styles.tableTitle}>DAO Assets</h4>
                    <InfoCircle
                        tooltipText={TREASURY_TAB_DESCRIPTIONS[TREASURY_TAB.ASSETS]}
                        className={styles.infoIcon}
                    />
                </div>
                <div className={styles.contentWrapper}>
                    <div className={`${styles.dataContainer} ${!isPremiumAllowed ? styles.blurred : ''}`}>
                        <div className={styles.tableContainer}>
                            <TableHeader sortByParam={sortByParam} sortedParamName={sortedParam.paramName} />

                            <div className={styles.rowsWrapper}>
                                <div className={styles.rowsContainer}>
                                    {daoAssetsTableData.map((currencyItems: IOrganizationAssetsTable) => (
                                        <AssetRowItems key={currencyItems.rank} {...currencyItems} />
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                    {isPremiumAllowed && !daoAssetsTableData?.length && (
                        <div className={!isPremiumAllowed ? styles.blurred : ''}>
                            <TableDataNotFound forTable overflowMarginsSecondVariant />
                        </div>
                    )}
                    {!isPremiumAllowed && (
                        <TableProBlur
                            title="DAO Assets is a DeepDAO Pro feature"
                            description={TREASURY_TAB_DESCRIPTIONS[TREASURY_TAB.ASSETS]}
                        />
                    )}
                </div>
            </div>
        </>
    );
};
